import AppLayout from '@/layout/app/index.vue';
import MasterLayout from '@/layout/master/index.vue';

const appRoutes = [
	{
		path: '/',
		component: AppLayout,
		name: 'AppHome',
		children: [
			{
				path: '/',
				name: 'homepage',
				component: () => import('@/pages/app/index/index.vue')
			},
			{
				path: '/article',
				name: 'article',
				component: () => import('@/pages/app/article/index.vue')
			},
			{
				path: '/exper',
				name: 'exper',
				component: () => import('@/pages/app/exper/index.vue')
			},
			{
				path: '/article/:id',
				name: 'articleDetail',
				component: () => import('@/pages/app/detail/article.vue')
			},
			{
				path: '/exper/:id',
				name: 'experDetail',
				component: () => import('@/pages/app/detail/exper.vue')
			},
			{
				path: '/user/:id',
				name: 'userDetail',
				component: () => import('@/pages/app/detail/user.vue')
			},
			{
				path: '/reg',
				name: 'register',
				component: () => import('@/pages/app/reg/index.vue')
			},
			{
				path: '/login',
				name: 'login',
				component: () => import('@/pages/app/login/index.vue')
			},
			{
				path: '/send',
				name: 'send',
				component: () => import('@/pages/app/send/index.vue')
			}
		]
	}
];

const masterRoutes = [
	{
		path: '/',
		component: MasterLayout,
		isMenu: true,
		name: 'MasterHome',
		meta: {
			title: '首页',
			icon: 'el-icon-s-home'
		},
		children: [
			{
				path: '/',
				name: 'homepage',
				component: () => import('@/pages/master/index/index.vue')
			}
		]
	},
	{
		path: '/account',
		component: MasterLayout,
		name: 'MasterAccount',
		isMenu: true,
		meta: {
			title: '账号管理',
			icon: 'el-icon-user-solid'
		},
		children: [
			{
				path: 'index',
				name: 'AccountIndex',
				isMenu: true,
				meta: {
					title: '账号信息',
				},
				component: () => import('@/pages/master/account/index.vue'),
			},
			{
				path: 'password',
				name: 'AccountPassword',
				isMenu: true,
				meta: {
					title: '设置密码',
				},
				component: () => import('@/pages/master/account/password.vue'),
			},
		]
	},
	{
		path: '/articles',
		component: MasterLayout,
		isMenu: true,
		name: 'MasterArticles',
		meta: {
			title: '我的文章',
			icon: 'el-icon-s-order'
		},
		children: [
			{
				path: 'index',
				name: 'ArticleLists',
				isMenu: true,
				meta: {
					title: '我的文章',
				},
				component: () => import('@/pages/master/article/index.vue')
			},
			{
				path: 'add',
				name: 'ArticleAdd',
				isMenu: false,
				meta: {
					title: '我的文章',
				},
				component: () => import('@/pages/master/article/add.vue')
			}
		]
	},
	{
		path: '/likes',
		component: MasterLayout,
		isMenu: true,
		name: 'MasterLikes',
		meta: {
			title: '我的收藏',
			icon: 'el-icon-star-on'
		},
		children: [
			{
				path: 'index',
				name: 'LikesLists',
				isMenu: true,
				meta: {
					title: '我的收藏',
				},
				component: () => import('@/pages/master/likes/index.vue')
			}
		]
	}
];

const config = {
	'www': {
		checkToken: false,
		routes: appRoutes
	},
	'master': {
		checkToken: true,
		routes: masterRoutes
	},
};


const routes = [
	{
		path: '/404',
		component: () => import('@/pages/app/error/404.vue'),
		isMenu: false
	},
	{ path: '*', name: 'page404', redirect: '/404', isMenu: false }
];


export default {
	routes,
	config,
};




// WEBPACK FOOTER //
// ./src/config/router.js